import React from 'react'

function LifeYoungItem ({list, current}) {
    const onMouseEnter = (index) => {
        current(index)
    }
    return (
        list.map((item, index) => {
            return (
                <li key={index} onMouseEnter={onMouseEnter.bind(this, index)}>
                    <div className="title lx-fz18 lx-fw600 lx-mb10">{ item.title }</div>
                    <div className="content lx-fz14">{ item.content }</div>
                </li>
            )
        })
    ) 
}

export default LifeYoungItem;